// ==============================|| OVERRIDES - CHIP ||============================== //

export default function Chip(theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          fontWeight: 500,
          fontSize: '0.75rem',
          padding: '4px 8px'
        },
        colorPrimary: {
          background: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)',
          color: theme.palette.primary.main,
          border: '1px solid rgba(102, 126, 234, 0.2)'
        },
        colorSecondary: {
          backgroundColor: theme.palette.secondary.lighter,
          color: theme.palette.secondary.main
        },
        colorSuccess: {
          backgroundColor: '#e8f5e9',
          color: '#2e7d32',
          border: '1px solid rgba(46, 125, 50, 0.2)'
        },
        colorError: {
          backgroundColor: '#ffebee',
          color: '#c62828',
          border: '1px solid rgba(198, 40, 40, 0.2)'
        },
        colorWarning: {
          backgroundColor: '#fff3e0',
          color: '#ef6c00',
          border: '1px solid rgba(239, 108, 0, 0.2)'
        },
        deleteIcon: {
          color: 'inherit',
          '&:hover': {
            color: 'inherit'
          }
        }
      }
    }
  };
}
